<!--
 * @Author: your name
 * @Date: 2021-10-29 14:00:05
 * @LastEditTime: 2021-11-16 10:45:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \adminCRM\src\components\customerCheck\index.vue
-->
<template>
<div id="customerCheck" style="display:flex;flex-direction:column;position: relative;">
  <div style="font-size:12px; position:absolute;top:-14.5px;left:80px;">客户信息查询</div>
  <div class="search" style="padding:0 20px 20px;">
    <div class="searchInline">
      <el-input v-model="searchParams.mobile" placeholder="请输入要查询的客户手机号" maxlength="11" clearable></el-input>
    </div>
    <div class="searchInline">
      <el-button type="primary" @click="submitSearch">搜索</el-button>
    </div>
    <div class="searchInline">
      <el-button type="primary" @click="searchClear()">清除</el-button>
    </div>
  </div>
  <div class="contentView" style="display:inline-block;">
    <customerUserInfo :mobile="searchParams.mobile" :update="update"></customerUserInfo>
    <customerLabel :mobile="searchParams.mobile" :update="update"></customerLabel>
    <customerCarInfo :mobile="searchParams.mobile" :update="update"></customerCarInfo>
    <customerInfoList :mobile="searchParams.mobile" :update="update"></customerInfoList>
    <div class="clear"></div>
  </div>
</div>
</template>

<script>
export default {
  name: 'customerCheck',
  components: {
    customerUserInfo: require('./userInfo.vue').default,
    customerLabel: require('./customerLabel.vue').default,
    customerCarInfo: require('./carInfo.vue').default,
    customerInfoList: require('./infoList.vue').default
  },
  data () {
    return {
      searchParams: {
        mobile: ''
      },
      update: ''
    };
  },
  created () {
    if (this.$route.query.mobile) {
      this.searchParams.mobile = this.$route.query.mobile;
      this.update = new Date().getTime();
    }
  },
  mounted () {
    document.getElementsByClassName('appIndex')[0].style.backgroundColor = '#eaedf1';
  },
  beforeDestroy () {
    document.getElementsByClassName('appIndex')[0].style.backgroundColor = '';
  },
  methods: {
    // 搜索
    submitSearch () {
      if (this.searchParams.mobile === '') {
        return this.$message.warning('请输入手机号查询');
      }
      this.update = new Date().getTime();
    },
    // 清除
    searchClear () {
      this.searchParams.mobile = '';
      // this.update = new Date().getTime();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
<style>
  .search {position: relative; top: 5px; display: inline-block;}
</style>



// WEBPACK FOOTER //
// src/components/customerCheck/index.vue